import { useEffect, useState } from 'react';
import { fetchPlatformAccess } from 'services/platform';

const cache = {
  status: 'idle', // idle | loading | ready
  allowed: false,
  promise: null,
};

export const getPlatformOrgAllowed = () =>
  cache.status === 'ready' ? cache.allowed : false;

/** Clear cached allowlist probe (call after login / token refresh). */
export const resetPlatformAccessCache = () => {
  cache.status = 'idle';
  cache.allowed = false;
  cache.promise = null;
};

export const loadPlatformAccess = () => {
  if (cache.promise) {
    return cache.promise;
  }
  cache.status = 'loading';
  cache.promise = fetchPlatformAccess()
    .then((response) => {
      if (!response?.success) {
        // Auth/network failure — allow a later retry (e.g. after re-login).
        resetPlatformAccessCache();
        return false;
      }
      const allowed = Boolean(response.raw?.allowed);
      cache.allowed = allowed;
      cache.status = 'ready';
      return allowed;
    })
    .catch(() => {
      resetPlatformAccessCache();
      return false;
    });
  return cache.promise;
};

/**
 * Shared allowlist probe for platform console. Fail-closed on error.
 */
export default function usePlatformAccess() {
  const [allowed, setAllowed] = useState(() =>
    cache.status === 'ready' ? cache.allowed : null
  );

  useEffect(() => {
    let mounted = true;
    loadPlatformAccess().then((value) => {
      if (mounted) setAllowed(value);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return {
    allowed,
    ready: allowed !== null,
  };
}
